import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import i18n from './i18n'
const fb = require('./firebaseConfig.js')
const util = require('util');
import c_es from './locales/countries/es.json'
import c_en from './locales/countries/en.json'
import c_de from './locales/countries/de.json'
import c_fr from './locales/countries/fr.json'
import c_it from './locales/countries/it.json'
import c_nl from './locales/countries/nl.json'



Vue.use(Vuex)

fb.auth.useDeviceLanguage();
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserProfile',{i18n: i18n})
        store.dispatch('fetchUserToken')
    }
   
})

const store = new Vuex.Store({
    state: {
        host: null,
        snaps: {},
        bg: '',
        currentUser: null,
        userProfile: {},
        userToken: null,
        userNotPresent: false,
        totalReconnected:0,
        timeout : null,
        userImage: require('@/assets/user_profile.png'),
        actionCodeSettings: {
            url: 'https://www.kripsolpool.com/login',
            handleCodeInApp: true
        },
        pools:[],
        detailUser: null,
        cached: {},
        cachedHello: {},
        cachedWeather: {},
        roles: [
            {code: 'admin', name:'Administrator'},
            {code: 'maintenance', name:'Maintenance'},
            {code: 'customer', name:'Customer'}
        ],
        languages: [
            {code: 'es', name:'Español', countries: c_es },
            {code: 'en', name:'English', countries: c_en},
            {code: 'de', name:'Deutsch', countries: c_de},
            {code: 'fr', name:'Français', countries: c_fr},
            {code: 'it', name:'Italiano', countries: c_it},
            {code: 'nl', name:'Nederlands', countries: c_nl},
            {code: 'pt', name:'Português', countries: c_es},
            {code: 'cz', name:'Čeština', countries: c_en}
        ],
        companies: [
            {code: 1, name:'Vistapool'}, 
            {code: 2, name:'Hayward'},
            {code: 3, name:'Naturally-salt'},
            {code: 4, name:'Da-gen'},
            {code: 5, name:'Kripsol'},
            {code: 6, name:'Brilix'},
            {code: 7, name:'Compass'}
        ],
        backgrounds: [
            {code: 1, name:'Pool image'},
            {code: 2, name:'Solid white'},
        ],
    },
    actions: {

        changeStyle({ commit },params) {
            var  val = (params && params.val) ? params.val : null
            //commit('changeStyle', val)
        },
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserProfile', {})
            commit('unsubscribeAll')
        },
        unsubscribe({commit}, params) {
            commit('unsubscribe', params.id)
        },
 
        fetchUserProfile({ commit, state }, params) {
            let host = window.location.host.toLowerCase()
            switch(host){
                case 'da-gen.vistapooltest.com':
                    state.company = 4
                break;
                case 'hayward.vistapool.es':
                case 'poolwatch.hayward.fr':
                    state.company = 2
                break;
                case 'kripsolpool.com':
                case 'www.kripsolpool.com':
                    state.company = 5
                break;
                case 'naturally-salt.vistapooltest.com':
                case 'localhost:8080':
                    state.company = 3
                break;
                case 'brilix.com':
                case 'app.brilix.com':
                    state.company = 6
                break;
                case 'compass-salt-water.com':
                    state.company = 7
                break;
                default:
                    state.company = 1
              }
    
            fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
                if(!res.exists){
                    fb.auth.signOut()
                    this.dispatch('clearData')
                }else{
                    let user = res.data()
                    commit('setUserProfile', user)
                    commit('setUserPrivileges', user)
                    this.dispatch('fetchUserPools')
                    if(!user.isAdmin){
                        fb.auth.setPersistence('session')
                    }
                    params.i18n._vm.locale = user.language
                }
            }).catch(err => {
               console.log('no user', err);
            })

        },

        getUserProfile({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                fb.usersCollection.where('email', '==', state.currentUser.email).where('company', '==',1).get().then(res => {
                    let user = null;
                    res.forEach(doc => {
                        user = doc.data()
                    })
                    // commit('setUserProfile', user)
                    // commit('setUserPrivileges', user)
                    // this.dispatch('fetchUserPools')
                    resolve(user)
                }).catch(err => {
                    reject(err);
                })
              
            })
           
        },

        setUserGDPR({ commit, state }){
            commit('setUserGDPR')
        },

        fetchUserPools({ commit, state }) {
            let userPools = state.userProfile.pools
            try{
                userPools.forEach( (element) => {
                    this.dispatch('poolSubscribe', element)
                })
                //Refresh connections after 10 minutes
                this.dispatch('setTimer')
            }catch(error){
                console.log(error)
            }
     
        },

        poolSubscribe({ commit, state }, poolId) {
            state.snaps[poolId] = fb.poolsCollection.doc(poolId).onSnapshot(res => {
                if(res.exists){
                    let pool = res.data();
                    pool.id = res.id;
                    //console.log('Pool data', pool.id);
            
                    //Check to reconnect pool after present false 
                    let current =  state.pools.find(x => x.id === pool.id);
                    if(current && pool.present == true && current.present == false) {
                        this.dispatch('prepareSend', pool)
                    }
                    store.commit('setPool', pool)
                    store.commit('getWeather', pool)
                    store.dispatch('sendHello')
                }
            })
        },

        fetchUserAlarms({ commit, state }, poolId) {
            return new Promise((resolve, reject) => {
                fb.alarmsCollection.where('pool', '==', poolId).where('user', '==', state.currentUser.uid).get().then(alarm => {
                    let alarms = [];
                    alarm.forEach(doc => {
                        let obj = doc.data()
                        obj.id  = doc.id
                        alarms.push(obj)
                    })
                    resolve(alarms)
                }).catch(err => {
                    console.log(err)
                    reject(err);
                })
             })
        },

        fetchUserToken({ commit, state }) {
            fb.auth.currentUser.getIdToken(/* forceRefresh */ true).then( (idToken) => {
                commit('setUserToken', idToken)
              }).catch(function(error) {
                // Handle error
              });
        },
        updateProfile({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                fb.usersCollection.doc(state.userProfile.id).update(data).then(user => {
                    console.log('user profile updated');
                    resolve(user)
                }).catch(err => {
                    reject(err);
                })
            })
        },
        addPool({ commit, state }, payload) {
            const pool = payload.pool;
            return new Promise((resolve, reject) => {
                fb.poolsCollection.doc(pool.node).set({ id: pool.node, form: pool}).then(pool => {
                    resolve(pool)
                }).catch(err => {
                    reject(err);
                })
            })
        },

        sendHello({ commit, state}){
            state.pools.forEach( (pool) => {
                this.dispatch('sendPUP', pool)
            });
        },
       //Reconnect pools after 10 minutes
        setTimer({commit, state}){
            state.timeout =  setTimeout(()=>{
                state.totalReconnected++;
                if(state.totalReconnected==3){
                    state.userNotPresent = true
                    state.totalReconnected = 0;
                    console.log('user present');
                }else{
                    console.log('reconnectPools');
                    this.dispatch('reconnectPools')
                }
     
            }, 600000);
        },
 
        reconnectPools({ commit, state}){
            console.log('reconnect pools')
            state.cachedHello = [];
            state.userNotPresent = false;
            state.pools.forEach( (pool) => {
                this.dispatch('sendPUP', pool)
            });
            clearTimeout(state.timeout) 
            this.dispatch('setTimer')
        },

        sendPUP({ commit, state}, pool){
            if(!state.cachedHello[pool.id] && pool.wifi != null){
                this.dispatch('prepareSend', pool)
            } else {
               
            }
        },

        prepareSend({ commit, state}, pool){
            let payload = {
                'wifi': pool.wifi,
                'id': pool.id,
                'operation': 'PUP',
                'changes': '10'//pool update period
            }
            console.log('send PUP', pool.id)
            this.dispatch('sendPoolCommand', payload)
            let cached = JSON.parse(JSON.stringify(pool));
            state.cachedHello[pool.id] = cached; 

        },

        getPoolStats({ commit, state}, payload) {
            const pool = payload.pool;
            const type = payload.type;
            const period = payload.period;
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);    
                const data = {
                    uuid: pool.id,
                    period: period,
                    type: type
                }
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }
                var _url = (type == 'admin') ? 'https://europe-west1-hayward-europe.cloudfunctions.net/getPoolStats' : 'https://europe-west1-hayward-europe.cloudfunctions.net/getStats';
                return new Promise((resolve, reject) => {
                    axios.post(_url, data, config).then( (response)=> {
                        resolve(response); 
                    }).catch(err => {
                        reject(err);
                    })
                })
            })
        },
        getDemoStats({ commit, state}, payload) {
            const pool = payload.pool;
            const type = payload.type;
            const period = payload.period;
            const authString = 'Bearer '.concat('demo');    
            const data = {
                uuid: pool.id,
                period: period,
                type: type
            }
            let config = {
                headers: {
                    'Authorization':  authString
                }
            }
            var _url =  'https://europe-west1-hayward-europe.cloudfunctions.net/getStats';
            return new Promise((resolve, reject) => {
                axios.post(_url, data, config).then( (response)=> {
                    resolve(response); 
                }).catch(err => {
                    reject(err);
                })
            })
            
        },
        sendPoolCommand({ commit, state}, payload) {
            const model = payload.pool;
            const changes = payload.changes;
            const operation = (payload.operation) ? payload.operation : 'WRP'
            const operationId = (payload.operationId) ? payload.operationId : null

            // console.log("Pool is AWS", payload)
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);     
                const data = {
                    gateway: payload.wifi,
                    poolId: payload.id,
                    operation: operation,
                    operationId: operationId,
                    changes: changes,
                    pool: null,
                    source: 'web'
                }
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }
                if(model){
                    data.pool = {
                        filtration: model.filtration,
                        backwash: model.backwash, 
                        hidro: model.hidro, 
                        light: model.light,
                        relays: model.relays,
                        main: model.main
                    }
                }
               // console.log(data, config);
                //this.dispatch('reconnectPools')
                const baseURL = "https://europe-west1-hayward-europe.cloudfunctions.net/sendCommand";
                return new Promise((resolve, reject) => {
                    axios.post(baseURL, data, config).then( (response)=> {
                        // console.log(response.data);
                        if(response.data){
                            resolve(response); 
                        } else {
                           // if(model){
                               // model.present = false;
                                console.log('Pool ID ', payload.id,' not connected')
                                this.dispatch("updatePool",{
                                    'id': payload.id, 
                                    'fields': { 'present': false}
                                })
                           // }
                            reject(null)
                        }   
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            })
        },

        sendPoolCommandAWS({ commit, state}, payload) {
            const model = payload.pool;
            const changes = payload.changes;
            const operation = (payload.operation) ? payload.operation : 'WRP'
            const operationId = (payload.operationId) ? payload.operationId : null

            // console.log("Pool is AWS", payload)
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);     
                const data = {
                    gateway: payload.wifi,
                    poolId: payload.id,
                    operation: operation,
                    operationId: operationId,
                    changes: changes,
                    pool: null,
                    source: 'web'
                }
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }

                const baseURL = "https://europe-west1-hayward-europe.cloudfunctions.net/sendPoolCommand";
                return new Promise((resolve, reject) => {
                    axios.post(baseURL, data, config).then( (response)=> {
                        if(response.status == 200){
                            resolve(response); 
                        } else {
                            // console.log(response.statusText);
                            this.dispatch("updatePool",{
                                'id': payload.id, 
                                'fields': { 'present': false}
                            })
                            reject(null)
                        }   
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            })
        },
        getAdminStats({ commit, state}, payload) {
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);     
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }
                let data = [];
                return new Promise((resolve, reject) => {
                    axios.post('https://europe-west1-hayward-europe.cloudfunctions.net/getTotalStats', data, config).then( (response)=> {
                        if(response.data){
                            resolve(response); 
                        } else {
                            reject(null)
                        }   
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            })
        },
        changeColor({ commit, state}, payload) {
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);     
                const data = {
                    gateway: payload.wifi,
                    poolId: payload.id,
                    type: payload.type
                }
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }

                return new Promise((resolve, reject) => {
                    axios.post('https://europe-west1-hayward-europe.cloudfunctions.net/changeLedColor', data, config).then( (response)=> {
                        if(response.data){
                            resolve(response); 
                        } else {
                            reject(null)
                        }   
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            })
        },

        getPoolProfile({ commit, state}, payload) {
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);     
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }
                const data = {
                    registers: payload.registers
                }
                return new Promise((resolve, reject) => {
                    axios.post('https://europe-west1-hayward-europe.cloudfunctions.net/getPoolProfile', data, config).then( (response)=> {
                        if(response.data){
                            resolve(response); 
                        } else {
                            reject(null)
                        }   
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            })
        },

        getUserById({ commit, state }, params) {
            const id = params.id
            let baseQuery = fb.usersCollection
        
            if(state.userProfile.role != 'superadmin'){
                baseQuery = baseQuery.where('company', '==',  state.userProfile.company);
            
            }

            const q = baseQuery
            return new Promise((resolve, reject) => {
                q.where('id', '==', id).get().then(res => {
                    let user = null
                    res.forEach(res => {
                        user = res.data();
                    })
                    resolve(user); 
                }).catch(err => {
                    reject(err);
                })
            })
        
        },
        getPoolById({ commit, state }, params) {
            const id = params.id
            let q = fb.poolsCollection
    
            return new Promise((resolve, reject) => {
                q.doc(id).get().then(res => {
                   if(res.exists){
                        let pool = res.data();
                        resolve(pool); 
                   }else{
                        reject('No valid pool');
                   }  
                }).catch(err => {
                    reject(err);
                })
            })
        },


        getSegmentedPools({ commit, state }) {
            let baseQuery = fb.poolsCollection
            baseQuery = baseQuery.where('updatedAt','>=', 1654041600);
           // baseQuery = baseQuery.limit(500)
            const q = baseQuery
       
            return new Promise((resolve, reject) => {
                q.get().then(res => {
                    let pools = [];
                    res.forEach(doc => {
                        let obj = doc.data()
                       // obj.form  = doc.id
                        if(obj.form){
                            pools.push(obj)
                        }
                      
                    })
                    console.log('resolved pools',pools.length);
                    resolve(pools)
                }).catch(err => {
                    console.log(err)
                    reject(err);
                })
            })
        },

        getAdminLocations({ commit, state }) {
            let baseQuery = fb.poolsCollection
            if(state.userProfile.role != 'superadmin'){
                baseQuery = baseQuery.where('company', '==',  state.userProfile.company);
            }
            baseQuery = baseQuery.limit(500)
            const q = baseQuery
       
            return new Promise((resolve, reject) => {
                q.get().then(res => {
                    let locations = [];
                    res.forEach(doc => {
                        let obj = doc.data()
                       // obj.form  = doc.id
                        if(obj.form){
                            locations.push(obj.form)
                        }
                      
                    })
                    resolve(locations)
                }).catch(err => {
                    console.log(err)
                    reject(err);
                })
            })
        },
        updateUser({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                fb.usersCollection.doc(params.id).update(params.fields).then(res => {
                    resolve(res); 
                }).catch(err => {
                    reject(err);
                })
            })
        },
        updatePool({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                console.log('update pool',params.id);
                fb.poolsCollection.doc(params.id).update(params.fields).then(res => {
                    resolve(res); 
                }).catch(err => {
                    reject(err);
                })
            })
        },
        updateAlarm({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                fb.alarmsCollection.doc(params.id).update(params.fields).then(res => {
                    resolve(res); 
                }).catch(err => {
                    reject(err);
                })
            })
        },
        addAlarm({ commit, state }, params) {
            let fields = params.fields;
            fields['user'] = state.currentUser.uid;
            return new Promise((resolve, reject) => {
                fb.alarmsCollection.add(fields).then(res => {
                    resolve(res); 
                }).catch(err => {
                    reject(err);
                })
            })
        },
        deleteAlarm({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                fb.alarmsCollection.doc(params.id).delete().then(res => {
                    resolve(res); 
                }).catch(err => {
                    reject(err);
                })
            })
        },
        sendPasswordResetEmail({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                fb.auth.sendPasswordResetEmail(params.email).then(res => {
                    resolve(res); 
                }).catch(err => {
                    reject(err);
                })
            })
        },
        userAdmin({ commit, state}, payload) {
            return fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                const authString = 'Bearer '.concat(idToken);     
                let config = {
                    headers: {
                        'Authorization':  authString
                    }
                }
                return new Promise((resolve, reject) => {
                    axios.post('https://europe-west1-hayward-europe.cloudfunctions.net/userAdmin', payload, config).then( (response)=> {
                        if(response.data){
                            resolve(response); 
                        } else {
                            reject(null)
                        }   
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            })
        },
    },
    mutations: {
        changeStyle(state, val) {
            /*if(val){
                state.bg = (val === 2) ? 'bgwhite' : '';
            } else {
                state.bg = (state.bg === '') ? 'bgwhite' : '';
            }*/

        },
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setCompany(state, val) {
            state.company = val
        },
        setUserProfile(state, val) {
            if(val && !val.pools){
                console.log('no pools')
                val['pools'] = []
            }
            state.userProfile = val
        },
        setUserPrivileges(state, user) {
        
            state.userProfile['isAdmin'] = (user.role == 'admin' || user.role == 'superadmin') ? true : false
            state.userProfile['isSuperAdmin'] = (user.role == 'superadmin') ? true : false
            state.userProfile['viewAdmin'] = (user.role == 'admin' || user.role == 'superadmin')? 1:0

        },
        setUserGDPR(state, val) {
            state.userProfile.GDPR = true
        },
        setUserImage(state, val) {
            state.userImage = val
        },

        setPool(state, pool){
            let index = state.pools.findIndex(x => x.id === pool.id);
            if(index < 0){
                state.pools.unshift(pool);
            } else {
                //state.pools[index] = JSON.parse(JSON.stringify(pool));
                Vue.set(state.pools,index,pool);
            }
            let cached = JSON.parse(JSON.stringify(pool));
            state.cached[pool.id] = cached;
        },
        setDetailUser(state, val) {
            state.detailUser = val
        },

        setUserToken(state, val) {
            state.userToken = val
        },
        getWeather(state, pool) {
            if(!state.cachedWeather[pool.id] && pool.form) {
                if(pool.form.lat && pool.form.lng){
                    const apiKey = 'ab45d97a63d38638726592b7599bea51';
                    const base = 'https://api.openweathermap.org/data/2.5/weather?units=metric&lat=%s&lon=%s&lang=%s&APPID=%s'
                    const lang = (state.userProfile.language) ? state.userProfile.language : 'en';
                    const url = util.format( base, pool.form.lat, pool.form.lng, lang, apiKey)
                
                    axios.post(url).then( (response)=> {
                        let res = response.data
                        let weather = {
                            description : res.weather[0].description,
                            icon : res.weather[0].icon, 
                            temp: Math.round(res.main.temp)
                        }
                        state.cachedWeather[pool.id] = weather;
                
                    }).catch(err => {
                        state.cachedWeather[pool.id] = { icon: null}
                        console.log(err);
                    })
                }
              
            }
        },
        unsubscribe(state, poolId) {
            state.snaps[poolId]()
        },
        unsubscribeAll(state) {
            Object.keys(state.snaps).forEach((key) => {
                state.snaps[key]()
                window.location.reload()
            })
        }
    },
    getters: {
        getUser: (state) => (val) => {
            return state.userProfile
        },
        getPoolById: (state) => (id) => {
            return state.pools.find(pool => pool.id === id)
        },
        getCachedData: (state) => (id) => {
            return state.cached[id]
        },
        getCachedWeather: (state) => (id) => {
            return state.cachedWeather[id]
        },
        getFiltrationMode: (state) => (val) => {
            var value = "";
            switch (val) {
                case 1:
                    value = "AUTO";
                    break;

                case 2:
                    value = "HEATING";
                    break;

                case 3:
                    value = "SMART";
                    break;

                case 4:
                    value = "INTEL";
                    break;

                default:
                    value =  "MANUAL";
                    break;
            }
            return value;
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store.js